import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApolloService } from '@src/app/services/apollo/apollo.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-password-forgotten',
  templateUrl: './password-forgotten.component.html',
  styleUrls: ['./password-forgotten.component.scss'],
  standalone: false,
})
export class PasswordForgottenComponent implements OnInit, OnDestroy {
  private _componentDestroyed$: Subject<void> = new Subject();
  // Form helpers
  public waitingForResponse: boolean = false;
  public completed: boolean = false; // prevent resending
  public messageBase: string = 'login.passwordForgotten.messages.'; // public as tests access this
  public message: string = '';
  public readonly maxLength: number = 255;
  public emailForm: FormGroup;

  constructor(
    private _apolloService: ApolloService,
    private _formBuilder: FormBuilder,
    private _router: Router,
  ) {
    this.emailForm = this._formBuilder.group({
      email: ['', [Validators.email, Validators.maxLength(this.maxLength), Validators.required]],
    });
  }

  /**
   * Send the request to the backend.
   */
  public submit(): void {
    if (this.emailForm.valid) {
      this.waitingForResponse = true;
      this._apolloService.passwordForgotten$(this.emailForm.controls.email.value)
        .pipe(takeUntil(this._componentDestroyed$))
        .subscribe({
          next: (success) => {
            this.waitingForResponse = false;
            this.message = this.messageBase + (success ? 'success' : 'failure');
            this.completed = success; // if success no retry
          },
          error: (_) => {
            this.waitingForResponse = false;
            this.message = this.messageBase + 'failure';
          },
        });
    } else {
      this.message = this.messageBase + 'invalidMail';
    }
  }

  /**
   * Navigate back.
   */
  public back(): void {
    this._router.navigateByUrl(
      'login',
      { state: { email: this.emailForm.controls.email.value } }
    );
  }

  /**
   * Gets possible e-mail from the state.
   */
  public ngOnInit(): void {
    if (history.state && history.state.email) {
      this.emailForm.setValue({
        email: history.state.email,
      });
    }
  }

  public ngOnDestroy(): void {
    this._componentDestroyed$.next();
  }
}
